import styled from 'styled-components';

export const StyleSpan = styled.span`
  display: inline-flex;
  align-items: center;
  color: #fe2f67;
`;
